module.exports = __webpack_public_path__ + "static/media/20b46dae-71f5-4019-9967-22917f56165e.71fc2a04.JPG";